export default __webpack_public_path__ + "static/media/toolbar-italic.85eb96f1.svg";